<template>
  <!-- ອະນຸມັດ / ປະຕິເສດ a shop change waiting for ຜູ້ບໍລິຫານ (owner, 2026-10-05):
       what changes (old → new), who asked and when. Rejecting needs a reason. -->
  <div class="approval-modal">
    <div class="info-box">
      <div class="info-row">
        <span>{{ $t("codAdvance.shop") }}</span>
        <b>{{ shopName }}</b>
      </div>
      <div class="info-row">
        <span>{{ $t("codAdvance.kind") }}</span>
        <b>{{ approval.kind === 'enroll' ? $t("codAdvance.kind_enroll") : $t("codAdvance.kind_update") }}</b>
      </div>
      <div class="info-row">
        <span>{{ $t("codAdvance.requested_by") }}</span>
        <b>{{ requesterName }}</b>
      </div>
      <div class="info-row">
        <span>{{ $t("codAdvance.requested_at") }}</span>
        <b>{{ formatDateTime(approval.requested_at) }}</b>
      </div>
    </div>

    <label class="fld-label">{{ $t("codAdvance.changes") }}</label>
    <div class="changes">
      <div class="change-row" v-for="row in rows" :key="row.field">
        <span class="change-label">{{ row.label }}</span>
        <span class="change-old">{{ row.old }}</span>
        <i class="fal fa-long-arrow-right"></i>
        <b class="change-new">{{ row.new }}</b>
      </div>
    </div>

    <div class="fld" v-if="rejecting">
      <label class="fld-label">{{ $t("codAdvance.reject_reason") }} <i class="req">*</i></label>
      <textarea class="fld-input" rows="3" v-model="reason" maxlength="500"
                :placeholder="$t('codAdvance.reject_reason_placeholder')"></textarea>
    </div>

    <p class="form-error" v-if="error">{{ error }}</p>

    <div class="modal-actions is-split" v-if="!rejecting">
      <button class="cod-btn is-danger" type="button" :disabled="saving" @click="rejecting = true">{{ $t("codAdvance.reject") }}</button>
      <button class="cod-btn" type="button" :disabled="saving" @click="approve">
        {{ saving ? $t("codAdvance.processing") : $t("codAdvance.approve") }}
      </button>
    </div>
    <div class="modal-actions is-split" v-else>
      <button class="cod-btn is-ghost" type="button" :disabled="saving" @click="rejecting = false">{{ $t("codAdvance.back") }}</button>
      <button class="cod-btn is-danger" type="button" :disabled="saving || !reason.trim()" @click="reject">
        {{ saving ? $t("codAdvance.processing") : $t("codAdvance.confirm_reject") }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  approveShopChange,
  describeChanges,
  errorMessage,
  formatDateTime,
  rejectShopChange,
} from '@/services/codAdvanceService';

export default {
  name: 'ApprovalModal',
  props: {
    approval: {type: Object, required: true},
    shopName: {type: String, default: ''},
  },
  data() {
    return {
      rejecting: false,
      reason: '',
      saving: false,
      error: null,
    };
  },
  computed: {
    rows() {
      return describeChanges(this.approval.changes);
    },
    requesterName() {
      const by = this.approval.requested_by;
      return (by && by.name) || '—';
    },
  },
  methods: {
    formatDateTime,
    async approve() {
      await this.decide(() => approveShopChange(this.approval.id), 'approved');
    },
    async reject() {
      if (!this.reason.trim()) return;
      await this.decide(() => rejectShopChange(this.approval.id, this.reason.trim()), 'rejected');
    },
    async decide(call, outcome) {
      if (this.saving) return;
      this.saving = true;
      this.error = null;
      try {
        await call();
        this.$emit('decided', outcome);
      } catch (e) {
        this.error = errorMessage(e, this.$t('codAdvance.action_failed'));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './cod-advance-ui';

.approval-modal {
  text-align: left;
  width: 460px;
  max-width: 100%;
  color: $cod-ink;
}

.changes {
  border: 1px solid $cod-line;
  border-radius: 10px;
  padding: 4px 14px;
  margin-bottom: 18px;
}

.change-row {
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 14px;
  border-bottom: 1px solid #f2f4f7;

  &:last-child {
    border-bottom: 0;
  }

  i {
    color: $cod-muted;
  }
}

.change-label {
  color: $cod-muted;
  font-size: 13px;
}

.change-old {
  color: $cod-muted;
  text-decoration: line-through;
}

.change-new {
  color: $cod-blue;
}
</style>
